import { constants } from '@yola/subscription-manager-js';

const { hostingPackageFeatureNames } = constants;

const getNotAvailableFeatures = (domainDiscount) => {
  const features = [];

  if (!domainDiscount) {
    features.push(hostingPackageFeatureNames.FREE_DOMAIN_PROMO);
  }

  return features;
};

export default getNotAvailableFeatures;
